import {ListItem} from '../ListItem'
import type {PullRequestMetadata, RunMetadata} from '@github-ui/repos-rules-types/rules-types'
import {userHovercardPath} from '@github-ui/paths'

function PresenceListItem({presence}: {presence: NonNullable<PullRequestMetadata['prPresence']>}) {
  const met = presence.state === 'completed'
  const login = presence.verifier?.login
  const avatarUrl = presence.verifier?.primaryAvatarUrl

  if (login) {
    return (
      <ListItem
        state={met ? 'success' : presence.state}
        avatarLabel={login}
        avatarUrl={avatarUrl ?? undefined}
        hovercardUrl={userHovercardPath({owner: login})}
        title={login}
        description={presence.summary}
      />
    )
  }

  return <ListItem state={met ? 'success' : presence.state} title={presence.summary} />
}

export function PullRequestList({metadata}: {metadata: RunMetadata}) {
  const {prReviewers, prPresence} = metadata as PullRequestMetadata
  return (
    <ul>
      {prReviewers.map(({state, stateSummary, user}) => (
        <ListItem
          key={user.login}
          state={state === 'approved' ? 'success' : state}
          avatarLabel={user.login}
          avatarUrl={user.primaryAvatarUrl}
          hovercardUrl={userHovercardPath({owner: user.login})}
          title={user.login}
          description={stateSummary}
        />
      ))}
      {prPresence && <PresenceListItem presence={prPresence} />}
    </ul>
  )
}
